import { render, staticRenderFns } from "./MessageIncomingVideo.vue?vue&type=template&id=6dd8377c&"
import script from "./MessageIncomingVideo.vue?vue&type=script&lang=js&"
export * from "./MessageIncomingVideo.vue?vue&type=script&lang=js&"
import style0 from "./MessageIncomingVideo.vue?vue&type=style&index=0&id=6dd8377c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VIcon,VResponsive})
